// Délégation d'événements : data-action="nom" data-args='[…]' remplace les gestionnaires inline window.actions.nom(…).
// Les deux formes coexistent : le registre est le même. data-champ="cle" écrit window.state.cle
// (data-type="int"|"bool"|"json"), data-champ-rendu="modal"|"content" redessine ensuite.
import { executer } from './actions.js';
import { state, setState } from './store.js';

function args(el) { try { return el.dataset.args ? JSON.parse(el.dataset.args) : []; } catch (e) { return []; } }
function convertir(el, v) {
    var t = el.dataset.type;
    if (t === 'int') return parseInt(v, 10) || 0;
    if (t === 'float') return parseFloat(v) || 0;
    if (t === 'bool') return !!(el.type === 'checkbox' ? el.checked : v);
    if (t === 'json') { try { return JSON.parse(v); } catch (e) { return null; } }
    return v;
}
function poserChamp(el) {
    var chemin = el.dataset.champ.split('.'), cible = state;
    for (var i = 0; i < chemin.length - 1; i++) { if (cible[chemin[i]] == null) cible[chemin[i]] = {}; cible = cible[chemin[i]]; }
    cible[chemin[chemin.length - 1]] = convertir(el, el.value);
    var rendu = el.dataset.champRendu;
    if (rendu === 'modal' && window.renderModal) window.renderModal();
    else if (rendu === 'content') setState({});
}
document.addEventListener('click', function(ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-action]') : null;
    if (!el || ev.defaultPrevented) return;
    if (el.hasAttribute('data-stop')) ev.stopPropagation();
    if (el.tagName === 'A') ev.preventDefault();
    executer(el.dataset.action, args(el), ev, el);
});
document.addEventListener('change', function(ev) {
    var el = ev.target;
    if (el && el.dataset && el.dataset.champ) poserChamp(el);
    if (el && el.dataset && el.dataset.changeAction) executer(el.dataset.changeAction, args(el), ev, el);
});
document.addEventListener('input', function(ev) {
    var el = ev.target;
    if (el && el.dataset && el.dataset.champ && el.hasAttribute('data-live')) poserChamp(el);
    if (el && el.dataset && el.dataset.inputAction) executer(el.dataset.inputAction, args(el), ev, el);
});
document.addEventListener('keydown', function(ev) {
    if (ev.key !== 'Enter') return;
    var el = ev.target;
    if (el && el.dataset && el.dataset.enter) { ev.preventDefault(); executer(el.dataset.enter, args(el), ev, el); }
});
